module.exports = __webpack_public_path__ + "img/svarochnoe-oborudovanie.a5085d57.svg";